/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/GetIndent.ts
 * @create:      2025-06-25 17:41:04.235
 * @modify:      2025-07-11 21:19:12.855
 * @version:     6.0.0
 * @times:       11
 * @lines:       64
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_Empty, Strings_WhiteSpace, Strings_Tab } from "../const/Strings";

/**
 * Returns the leading indentation (spaces and tabs) from the beginning of the given string.
 *
 * Iterates through the input string and collects all consecutive whitespace or tab characters
 * from the start, stopping at the first non-whitespace, non-tab character.
 *
 * @param str - The input string from which to extract the indentation.
 * @returns A string containing the leading whitespace and tab characters, or an empty string if none are found.
 * 
 * @since 4.0.0
 * @version 2021-12-11
 */
export function GetIndent(str: string) {
    if (str.length > 0) {
        let result = Strings_Empty;
        for (const c of str) {
            if (c === Strings_WhiteSpace || c === Strings_Tab) {
                result += c;
                continue;
            }

            break;
        }

        return result;
    }

    return Strings_Empty;
}
